import * as types from './types';
export default {
  [types.SET_CART_SUCCESS](state, payload) {
    const currentState = state;
    currentState.success = payload;
  },

  [types.SET_CART](state, payload) {
    const currentState = state;
    currentState.items = payload;
  },

  [types.SET_CART_QTY](state, payload) {
    const currentState = state;
    currentState.total = payload;
  }

};